import { render, staticRenderFns } from "./inAppEditor.vue?vue&type=template&id=39c23d48&"
import script from "./inAppEditor.vue?vue&type=script&lang=js&"
export * from "./inAppEditor.vue?vue&type=script&lang=js&"
import style0 from "./inAppEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports